import { initializeApp } from 'firebase/app';
import { getFunctions } from 'firebase/functions';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import {
    initializeFirestore,
    persistentLocalCache,
    persistentMultipleTabManager,
} from 'firebase/firestore';
import { initializeAppCheck, ReCaptchaV3Provider } from 'firebase/app-check';

// Mismo Client ID que en Firebase Console > Authentication > Sign-in method > Google (Web client ID).
export const GOOGLE_ONE_TAP_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || '';

// Si está seteada REACT_APP_APPCHECK_SITE_KEY activamos App Check con reCAPTCHA v3.
const APPCHECK_SITE_KEY = process.env.REACT_APP_APPCHECK_SITE_KEY || '';

let app;
let functions;
let auth;
let db;
let googleProvider;

try {
    const firebaseConfig = {
        apiKey: 'AIzaSyBTCUCrqTS9e6A63NtZhDO8f9IFUcpASgQ',
        authDomain: 'privilead.com',
        projectId: 'local-leads-c5e93',
        storageBucket: 'local-leads-c5e93.firebasestorage.app',
        messagingSenderId: '750856891882',
        appId: '1:750856891882:web:bd3b038daee1e9a5821693',
        measurementId: 'G-5SQGN80S7S',
    };

    app = initializeApp(firebaseConfig);

    if (APPCHECK_SITE_KEY) {
        try {
            initializeAppCheck(app, {
                provider: new ReCaptchaV3Provider(APPCHECK_SITE_KEY),
                isTokenAutoRefreshEnabled: true,
            });
        } catch (e) {
            console.warn('App Check no pudo inicializarse:', e?.message);
        }
    }

    functions = getFunctions(app, 'us-central1');
    auth = getAuth(app);
    googleProvider = new GoogleAuthProvider();

    // Firestore con caché local moderna (reemplaza enableMultiTabIndexedDbPersistence).
    // persistentLocalCache + persistentMultipleTabManager permiten compartir la misma
    // caché entre todas las pestañas sin romper al abrir varias.
    db = initializeFirestore(app, {
        localCache: persistentLocalCache({
            tabManager: persistentMultipleTabManager(),
        }),
    });
} catch (error) {
    console.error('Error inicializando Firebase:', error);
}

export { functions, auth, db, googleProvider };
